export const hasServiceWorkerStatusActivated = () =>
  navigator.serviceWorker.controller?.state === 'activated'
